import { Component, Vue} from 'vue-property-decorator';
import { COMMON_METRICS } from './columns'

@Component
export default class BaseMetricsMixin extends Vue {
  get baseMetrics()  {
    let custom: { [type: string]: Bemob.MetricsHelpAggregated } = {};
    let customWeights: { [type: string]: number } = {};

    for(let i = 1; i <= 10; i++) {
      const customKey: string = 'reports-custom' + i;
      const customKeyMasked: string = `reports-custom${i}masked`;
      const trafficSourcesKey: string = `traffic_sources-custom${i}param`;

      custom[trafficSourcesKey] = {
        short: this.t('Parameter for passing additional traffic data'),
        full: this.t('Parameter from traffic source settings which is used to pass the additional details on traffic data.')
      }

      custom[customKey] = {
        short: this.t('Parameter for passing additional traffic data'),
        full: this.t('Parameter from traffic source settings which is used to pass the additional details on traffic data.')
      }

      custom[customKeyMasked] = {
        short: this.t('Masked value of custom parameter'),
        full: this.t('Masked value of the corresponding parameter of traffic source.')
      }

      customWeights[customKey] = customWeights[trafficSourcesKey] = 100;
    }

    return {
      avaliable_metrics: [],
      default_omit: COMMON_METRICS.defaultUnselected,
      default_include: COMMON_METRICS.defaultSelected,
      default_sort: COMMON_METRICS.defaultSort,
      metrics_filters: COMMON_METRICS.filters,
      report_exclude: COMMON_METRICS.exclude,
      metrics_help:{
        'campaigns-name': {
          short: this.t('Name of the campaign'),
          full: this.t('The campaign name is based on selected traffic source, country tag and unique custom name. Name preferences should be set up in Settings -> General -> Reporting.')
        },
        'campaigns-url': {
          short: this.t('Link of your ad campaign'),
          full: this.t('Unique campaign link which should be added on the side of your traffic source. This URL redirects a visitor of your ad campaign to a landing page or an offer link set in BeMob.')
        },
        'campaigns-externalstatus': {
          short: this.t('Status of the campaign received from a traffic source'),
          full: this.t('Status of the campaign received from a traffic source.')
        },
        'campaigns-externalid': {
          short: this.t('Unique ID assigned to a campaign on the side of a traffic source'),
          full: this.t('Unique ID assigned to a campaign on the side of a traffic source.')
        },
        'workspaces-name': {
          short: this.t('Custom name of the workspace'),
          full: this.t('Name of workspace to which the element belongs.')
        },
        'campaigns-id': {
          short: this.t('Unique ID of campaign'),
          full: this.t('The unique ID is assigned to each campaign in tracker. This ID will be displayed in the campaign URL.')
        },
        'campaigns-created': {
          short: this.t('Timestamp of element creation'),
          full: this.t('Timestamp of element creation')
        },
        'campaigns-updated': {
          short: this.t('Timestamp of the last change'),
          full: this.t('Timestamp of the last change')
        },
        'campaigns-updatedby': {
          short: this.t('Name of User who introduced the latest changes'),
          full: this.t('Name of User who introduced the latest changes')
        },
        'campaigns-countryid': {
          short: this.t('Name of country'),
          full: this.t('Country selected in campaign settings.')
        },
        'campaigns-trafficsourceid': {
          short: this.t('Name of traffic source'),
          full: this.t('Platform which generates traffic for the campaign.')
        },
        'campaigns-costmodel': {
          short: this.t('Model selected in campaign settings'),
          full: this.t('Model which defines how the payment for traffic is organized with the traffic source.')
        },
        'campaigns-costvalue': {
          short: this.t('Amount of money paid for traffic'),
          full: this.t('Indicates the fixed value paid to the traffic source according to cost model selected.')
        },
        'reports-impressions': {
          short: this.t('Impressions amount for selected period'),
          full: this.t('An impression is registered each time the dedicated impression pixel loads along with your ad banner.')
        },
        'reports-impressionsuniq': {
          short: this.t('Unique impressions for selected period'),
          full: this.t('Shows the number of impressions registered for a campaign within specified uniqueness period.')
        },
        'reports-impressionsbot': {
          short: this.t('Bot impressions for selected period'),
          full: this.t('Indicates the amount of impressions considered as suspicious according to the bot rules.')
        },
        'reports-visits': {
          short: this.t('Visits amount for selected period'),
          full: this.t('A visit is registered each time the Campaign URL is accessed.')
        },
        'reports-visitsuniq': {
          short: this.t('Unique visits for selected period'),
          full: this.t('Shows the number of visits registered for a campaign within specified uniqueness period.')
        },
        'reports-visitsbot': {
          short: this.t('Bot visits for selected period'),
          full: this.t('Indicates the amount of visits considered as suspicious according to the bot rules.')
        },
        'reports-costbot': {
          short: this.t('Cost generated by bot traffic.'),
          full: this.t('Displays the cost generated by visits identified by the system as bot traffic. The value is part of the total cost, but is recorded in this separate column to help evaluate spending on bot traffic.')
        },
        'reports-clicks': {
          short: this.t('Clicks amount for selected period'),
          full: this.t('A click is registered each time when the CTA button on the landing page is clicked.')
        },
        'reports-clicksuniq': {
          short: this.t('Unique clicks for selected period'),
          full: this.t('Shows the number of clicks registered for a campaign within specified uniqueness period.')
        },
        'reports-clicksbot': {
          short: this.t('Bot clicks for selected period'),
          full: this.t('Indicates the amount of clicks considered as suspicious according to the bot rules.')
        },
        'reports-conversionnew': {
          short: this.t('New conversions amount'),
          full: this.t('New conversion appears each time the postback URL/pixel passes the corresponding value specified in settings of Affiliate Network.')
        },
        'reports-conversionsent': {
          short: this.t('Conversions that were sent to the traffic source.'),
          full: this.t('Conversions that were sent to the traffic source.')
        },
        'reports-conversions': {
          short: this.t('Total conversions amount'),
          full: this.t('All the custom conversions and conversions with statuses associated with the campaign or the element for a selected timeframe.')
        },
        'reports-conversionconfirm': {
          short: this.t('Approved conversions amount'),
          full: this.t('Confirmed conversion appears each time the postback URL/pixel passes the corresponding value specified in settings of Affiliate Network.')
        },
        'reports-conversionconfirmhiddenrevenue': {
          short: this.t('Revenue of conversions with confirmed status that was not sent to the traffic source.'),
          full: this.t('Revenue of conversions with confirmed status that was not sent to the traffic source.')
        },
        'reports-conversionchargerevenue': {
          short: this.t('Revenue from conversions with the status “Charged”.<br>Displayed as a negative value.'),
          full: this.t('Revenue from conversions with the status “Charged”.<br>Displayed as a negative value.')
        },
        'reports-conversionconfirmrevenue': {
          short: this.t('Revenue of conversions with confirmed status.'),
          full: this.t('Revenue of conversions with confirmed status.')
        },
        'reports-conversiondecline': {
          short: this.t('Declined conversions amount'),
          full: this.t('Declined conversion appears each time the postback URL/pixel passes the corresponding value specified in settings of Affiliate Network.')
        },
        'reports-conversioncharge': {
          short: this.t('Chargeback conversions for selected period'),
          full: this.t('With this status received in tracker, the revenue of conversion will be subtracted from the stats.')
        },
        'reports-revenue': {
          short: this.t('Registered number of conversions * Payout'),
          full: this.t('Shows the payout value received for a successful conversion.')
        },
        'reports-hiddenrevenue': {
          short: this.t('Revenue - Revenue of conversions sent to the traffic source via postback'),
          full: this.t('Shows the revenue of conversions which were not sent to the traffic source when Send Postbacks % option is active.')
        },
        'reports-cost': {
          short: this.t('Traffic cost for the selected period'),
          full: this.t('Indicates the amount of money paid to the traffic source.')
        },
        'reports-profit': {
          short: this.t('Revenue - Cost'),
          full: this.t('Revenue - Cost. The amount of money earned.')
        },
        'reports-cpc': {
          short: this.t('Cost / Clicks'),
          full: this.t('Cost / Clicks. Cost of one click.')
        },
        'reports-cpv': {
          short: this.t('Cost / Visits'),
          full: this.t('Cost/ Visits. Cost of one visit.')
        },
        'reports-ctr': {
          short: this.t('Clicks / Visits * 100%'),
          full: this.t('Clicks / Visits * 100%. Click-through rate of landing page.')
        },
        'reports-1xctr': {
          short: this.t('1 : Visits / Clicks'),
          full: this.t('Indicates the number of visits accounted to 1 click.')
        },
        'reports-uctr': {
          short: this.t('Unique Сlicks / Unique Visits * 100%'),
          full: this.t('Unique Clicks / Unique Visits * 100%. Landing page click-through rate for unique traffic.')
        },
        'reports-cr': {
          short: this.t('Conversions / Clicks * 100%'),
          full: this.t('Conversions / Clicks * 100%. Conversion rate counted for a campaign with landing page.')
        },
        'reports-1xcr': {
          short: this.t('1 : Clicks / Conversions'),
          full: this.t('Indicates the number of clicks accounted to 1 conversion.')
        },
        'reports-cv': {
          short: this.t('Conversions / Visits * 100%'),
          full: this.t('Conversions / Visits * 100%. Conversion rate counted for a campaign with direct linking.')
        },
        'reports-1xcv': {
          short: this.t('1 : Visits / Conversions'),
          full: this.t('Indicates the number of visits accounted to 1 conversion.')
        },
        'reports-roi': {
          short: this.t('(Revenue - Cost) / Cost * 100%'),
          full: this.t('Return on investment shows the percentage of the money earned to the money invested.')
        },
        'reports-epv': {
          short: this.t('Revenue / Visits'),
          full: this.t('Revenue / Visits. Earn per visit')
        },
        'reports-epc': {
          short: this.t('Revenue / Clicks'),
          full: this.t('Revenue / Clicks. Earn per click.')
        },
        'reports-ap': {
          short: this.t('Revenue / Conversions'),
          full: this.t('Revenue / Conversions. Average price of a conversion.')
        },
        'offers-name': {
          short: this.t('Name of offer'),
          full: this.t('The offer name is based on country tag and unique custom name. Name preferences for offer name in report should be set up in Settings -> General -> Reporting.')
        },
        'offers-id': {
          short: this.t('Unique ID of offer'),
          full: this.t('Unique ID assigned to the offer in tracker.')
        },
        'offers-url': {
          short: this.t('Link of offer'),
          full: this.t('Link provided by affiliate network or direct advertizer.')
        },
        'offers-countryid': {
          short: this.t('Name of country'),
          full: this.t('Country selected in offer settings.')
        },
        'offers-payout': {
          short: this.t('Expected revenue for conversion'),
          full: this.t('Value specified in offer settings with manual payout tracking selected.')
        },
        'offers-affiliatenetworkid': {
          short: this.t('Network associated with offer'),
          full: this.t('Affiliate network is a platform which contains multiple offers on various niches.')
        },
        'offers-created': {
          short: this.t('Timestamp of element creation'),
          full: this.t('Timestamp of element creation')
        },
        'offers-updated': {
          short: this.t('Timestamp of the last change'),
          full: this.t('Timestamp of the last change')
        },
        'offers-updatedby': {
          short: this.t('Name of User who introduced the latest changes'),
          full: this.t('Name of User who introduced the latest changes')
        },
        'landings-name': {
          short: this.t('Name of the landing page'),
          full: this.t('The  landing page name is based on country tag and unique custom name. Name preferences for landing page name in report  should be set up in Settings -> General -> Reporting.')
        },
        'landings-id': {
          short: this.t('Unique ID of landing page'),
          full: this.t('The unique ID is assigned to each landing page in tracker.')
        },
        'landings-url': {
          short: this.t('Link of the landing page'),
          full: this.t('URL of landing page which is an externally hosted web page which contains CTA links or buttons that lead to the offer page.')
        },
        'landings-countryid': {
          short: this.t('Name of country'),
          full: this.t('Country selected in landing page settings.')
        },
        'landings-offers': {
          short: this.t('Number of offers'),
          full: this.t('Number of offers should match the number of click URLs placed on landing page code.')
        },
        'landings-created': {
          short: this.t('Timestamp of element creation'),
          full: this.t('Timestamp of element creation')
        },
        'landings-updated': {
          short: this.t('Timestamp of the last change'),
          full: this.t('Timestamp of the last change')
        },
        'landings-updatedby': {
          short: this.t('Name of User who introduced the latest changes'),
          full: this.t('Name of User who introduced the latest changes')
        },
        'flows-name': {
          short: this.t('Name of flow'),
          full: this.t('The  flow name is based on country tag, custom name and the date and time of flow creation. Name preferences for flow name in report should be set up in Settings -> General -> Reporting.')
        },
        'flows-id': {
          short: this.t('Unique ID of flow'),
          full: this.t('Unique ID assigned to the flow in tracker.')
        },
        'flows-created': {
          short: this.t('Timestamp of element creation'),
          full: this.t('Timestamp of element creation')
        },
        'flows-updated': {
          short: this.t('Timestamp of the last change'),
          full: this.t('Timestamp of the last change')
        },
        'flows-updatedby': {
          short: this.t('Name of User who introduced the latest changes'),
          full: this.t('Name of User who introduced the latest changes')
        },
        'flows-offersAmount': {
          short: this.t('Number of offers'),
          full: `${this.t('Number of offers added in the flow')}.`,
        },
        'flows-landingsAmount': {
          short: this.t('Number of landings'),
          full: `${this.t('Number of landings added in the flow')}.`,
        },
        'traffic_sources-name': {
          short: this.t('Official or custom name of traffic source'),
          full: this.t('If traffic source is added from the template, the name will be pre-filled with the official name of traffic source. Also custom name can be added in traffic source settings.')
        },
        'traffic_sources-id': {
          short: this.t('Unique ID of traffic source'),
          full: this.t('The unique ID is assigned to each traffic source in tracker.')
        },
        'traffic_sources-postbackurl': {
          short: this.t('Dedicated traffic source URL'),
          full: this.t('Dedicated URL of traffic source for conversions passing from tracker to the side of traffic source.')
        },
        'traffic_sources-extclickidparam': {
          short: this.t('Traffic source parameter for click ID'),
          full: this.t('Parameter from traffic source settings which is used to pass the unique click identifier from traffic source to tracker.')
        },
        'traffic_sources-costparam': {
          short: this.t('Traffic source parameter for cost'),
          full: this.t('Cost parameter is required to pass the cost data from traffic source to the tracker through dedicated parameter.')
        },
        'traffic_sources-created': {
          short: this.t('Timestamp of element creation'),
          full: this.t('Timestamp of element creation')
        },
        'traffic_sources-updated': {
          short: this.t('Timestamp of the last change'),
          full: this.t('Timestamp of the last change')
        },
        'traffic_sources-updatedby': {
          short: this.t('Name of User who introduced the latest changes'),
          full: this.t('Name of User who introduced the latest changes')
        },
        'affiliate_networks-name': {
          short: this.t('Official or custom name of affiliate network'),
          full: this.t('If affiliate network is added from the template, the name will be pre-filled with the official name of affiliate network. Also custom name can be added in affiliate network settings.')
        },
        'affiliate_networks-id': {
          short: this.t('Unique ID of affiliate network'),
          full: this.t('Unique ID assigned to the affiliate network in tracker.')
        },
        'affiliate_networks-appendclickid': {
          short: this.t('Parameter for passing click ID automatically'),
          full: this.t('This parameter allows to add the click ID parameter of affiliate network and the dedicated BeMob token {clickId} at the end of each offer URL associated with this affiliate network.')
        },
        'affiliate_networks-postbackonlywhiteips': {
          short: this.t('Allows to avoid postbacks from untrusted IPs'),
          full: this.t('The option is required to receive the postback requests from trusted IPs only.')
        },
        'affiliate_networks-created': {
          short: this.t('Timestamp of element creation'),
          full: this.t('Timestamp of element creation')
        },
        'affiliate_networks-updated': {
          short: this.t('Timestamp of the last change'),
          full: this.t('Timestamp of the last change')
        },
        'affiliate_networks-updatedby': {
          short: this.t('Name of User who introduced the latest changes'),
          full: this.t('Name of User who introduced the latest changes')
        },
        'reports-language': {
          short: this.t('Name of language'),
          full: this.t('Language of visitor’s browser.')
        },
        'reports-city': {
          short: this.t('Name of city'),
          full: this.t('Name of city the report is based on.')
        },
        'reports-state': {
          short: this.t('Name of state or region'),
          full: this.t('Name of state or region the report is based on.')
        },
        'reports-country': {
          short: this.t('Name of country'),
          full: this.t('Name of country the report is based on.')
        },
        'reports-isp': {
          short: this.t('Internet Service Provider'),
          full: this.t('Internet Service Provider the report is based on.')
        },
        'reports-mobilecarrier': {
          short: this.t('Name of mobile carrier'),
          full: this.t('Mobile carrier of device the report is based on.')
        },
        'reports-connecttype': {
          short: this.t('Name of connection type'),
          full: this.t('Connection type the report is based on.')
        },
        'reports-devicemodel': {
          short: this.t('Name of device model'),
          full: this.t('Model of device the report is based on.')
        },
        'reports-devicevendor': {
          short: this.t('Name of device vendor'),
          full: this.t('Vendor of device the report is based on.')
        },
        'reports-devicetype': {
          short: this.t('Name of device type'),
          full: this.t('Type of device the report is based on.')
        },
        'reports-screenresolution': {
          short: this.t('Width × height of the device screen'),
          full: this.t('Screen resolution the report is based on.')
        },
        'reports-os': {
          short: this.t('Operating system name'),
          full: this.t('Operating system the report is based on.')
        },
        'reports-osversion': {
          short: this.t('Operating system version name'),
          full: this.t('Version of operating system the report is based on.')
        },
        'reports-browser': {
          short: this.t('Name of browser'),
          full: this.t('Name of browser the report is based on.')
        },
        'reports-browserversion': {
          short: this.t('Version of browser data'),
          full: this.t('Version of browser the report is based on.')
        },
        'useragents-useragent': {
          short: this.t('User agent of visitor’s browser'),
          full: this.t('User agent data the report is based on.')
        },
        'ips-ip': {
          short: this.t('IP address'),
          full: this.t('IP address the report is based on.')
        },
        'reports-subnetsmall': {
          short: this.t('Small subdivisions of IP address'),
          full: this.t('Small subdivision of IP address the report is based on.')
        },
        'reports-subnetbig': {
          short: this.t('Big subdivisions of IP address'),
          full: this.t('Big subdivision of IP address the report is based on.')
        },
        'referrers-referrer': {
          short: this.t('Referrer data'),
          full: this.t('Referrer the report is based on.')
        },
        'referrer_domains-name': {
          short: this.t('Referrer domain data'),
          full: this.t('Referrer domain the report is based on.')
        },
        'reports-month': {
          short: this.t('Month name'),
          full: this.t('The report is based on the selected month of the year.')
        },
        'reports-day': {
          short: this.t('Date of the month'),
          full: this.t('The report is based on the selected date of the month.')
        },
        'reports-dayofweek': {
          short: this.t('Name of the day'),
          full: this.t('Day of week the report is based on.')
        },
        'reports-hourofday': {
          short: this.t('Day hour'),
          full: this.t('Hour of day the report is based on.')
        },
        'reports-impressionswebview': {
          short: this.t('Amount of impressions associated with WebView traffic'),
          full: `${this.t('Amount of impressions associated with WebView traffic')}.`,
        },
        'reports-visitswebview': {
          short: this.t('Amount of visits associated with WebView traffic'),
          full: `${this.t('Amount of visits associated with WebView traffic')}.`,
        },
        'reports-clickswebview': {
          short: this.t('Amount of clicks associated with WebView traffic'),
          full: `${this.t('Amount of clicks associated with WebView traffic')}.`,
        },
        'reports-impressionssuspicious': {
          short: this.t('Total amount of impressions considered as suspicious'),
          full: `${this.t('Total amount of impressions considered as suspicious')}.`,
        },
        'reports-impressionssuspiciousblacklistedips': {
          short: this.t('Impressions that come from the blacklisted IPs'),
          full: `${this.t('Impressions that come from the blacklisted IPs')}.`,
        },
        'reports-impressionssuspiciousdatacenterips': {
          short: this.t('Impressions that come from the IPs that belong to known data centers'),
          full: `${this.t('Impressions that come from the IPs that belong to known data centers')}.`,
        },
        'reports-visitssuspicious': {
          short: this.t('Total amount of visits considered as suspicious'),
          full: `${this.t('Total amount of visits considered as suspicious')}.`,
        },
        'reports-visitssuspiciousblacklistedips': {
          short: this.t('Visits that come from the blacklisted IPs'),
          full: `${this.t('Visits that come from the blacklisted IPs')}.`,
        },
        'reports-visitssuspiciousdatacenterips': {
          short: this.t('Visits that come from the IPs that belong to known data centers'),
          full: `${this.t('Visits that come from the IPs that belong to known data centers')}.`,
        },
        'reports-clickssuspicious': {
          short: this.t('Total amount of clicks considered as suspicious'),
          full: `${this.t('Total amount of clicks considered as suspicious')}.`,
        },
        'reports-clickssuspiciousblacklistedips': {
          short: this.t('Clicks that come from the blacklisted IPs'),
          full: `${this.t('Clicks that come from the blacklisted IPs')}.`,
        },
        'reports-clickssuspiciousdatacenterips': {
          short: this.t('Clicks that come from the IPs that belong to known data centers'),
          full: `${this.t('Clicks that come from the IPs that belong to known data centers')}.`,
        },
        'reports-impressions_suspicious_ip_with_frequent_events': {
          short: this.t('The impressions in this column are defined as frequent because they are made from IPs that generate the unusual amount of events'),
          full: `${this.t('The impressions in this column are defined as frequent because they are made from IPs that generate the unusual amount of events')}.`,
        },
        'reports-visits_suspicious_ip_with_frequent_events': {
          short: this.t('The visits in this column are defined as frequent because they are made from IPs that generate the unusual amount of events'),
          full: `${this.t('The visits in this column are defined as frequent because they are made from IPs that generate the unusual amount of events')}.`,
        },
        'reports-clicks_suspicious_ip_with_frequent_events': {
          short: this.t('The clicks in this column are defined as frequent because they are made from IPs that generate the unusual amount of events'),
          full: `${this.t('The clicks in this column are defined as frequent because they are made from IPs that generate the unusual amount of events')}.`,
        },
        'reports-impressions_suspicious_ip_with_frequent_campaign_events': {
          short: this.t('The impressions in this column are defined as frequent because they are made from IPs that generate the unusual amount of events within one ad campaign'),
          full: `${this.t('The impressions in this column are defined as frequent because they are made from IPs that generate the unusual amount of events within one ad campaign')}.`,
        },
        'reports-visits_suspicious_ip_with_frequent_campaign_events': {
          short: this.t('The visits in this column are defined as frequent because they are made from IPs that generate the unusual amount of events within one ad campaign'),
          full: `${this.t('The visits in this column are defined as frequent because they are made from IPs that generate the unusual amount of events within one ad campaign')}.`,
        },
        'reports-clicks_fast_clicker': {
          short: this.t('The clicks in this column are defined as frequent because they have less than 800 ms between ad visit and the click on CTA button, which can be classified as suspicious behaviour'),
          full: `${this.t('The clicks in this column are defined as frequent because they have less than 800 ms between ad visit and the click on CTA button, which can be classified as suspicious behaviour')}.`,
        },
        'reports-clicks_suspicious_ip_with_frequent_campaign_events': {
          short: this.t('The clicks in this column are defined as frequent because they are made from IPs that generate the unusual amount of events within one ad campaign'),
          full: `${this.t('The clicks in this column are defined as frequent because they are made from IPs that generate the unusual amount of events within one ad campaign')}.`,
        },
        'reports-cpa': {
          short: this.t('Сost / (Сonversions Confirmed + Custom Conversions with Revenue Included) - Conversions With Chargeback'),
          full: this.t('Сost / (Сonversions Confirmed + Custom Conversions with Revenue Included) - Conversions With Chargeback. <br>Cost per one conversion.'),
        },
        'reports-hiddenprofit': {
          short: this.t('Profit + Hidden Revenue.'),
          full: this.t('Profit + Hidden Revenue.<br>Profit data on conversions that have not been sent to the traffic source when the “Send Postbacks %” option is used.'),
        },
        'campaigns-number': {
          short: this.t('Serial number of the created campaign.'),
          full: this.t('Serial number of the created campaign.')
        },
        'offers-number': {
          short: this.t('Serial number of the created offer.'),
          full: this.t('Serial number of the created offer.')
        },
        'landings-number': {
          short: this.t('Serial number of the created landing page.'),
          full: this.t('Serial number of the created landing page.')
        },
        'flows-number': {
          short: this.t('Serial number of the flow.'),
          full: this.t('Serial number of the flow.')
        },
        'affiliate_networks-number': {
          short: this.t('Serial number of the created affiliate network.'),
          full: this.t('Serial number of the created affiliate network.')
        },
        'traffic_sources-number': {
          short: this.t('Serial number of the created traffic source.'),
          full: this.t('Serial number of the created traffic source.')
        },
        'flow_rule_paths-name': {
          short: this.t('Flow Path Name'),
          full: this.t('Flow Path Name')
        },
        'flow_rule_paths-id': {
          short: this.t('Unique ID assigned to the flow path in BeMob'),
          full: this.t('Unique ID assigned to the flow path in BeMob')
        },
        'flow_rule_paths-number': {
          short: this.t('Serial number of the flow path'),
          full: this.t('Serial number of the flow path')
        },
        'flow_rule_paths-directlinking': {
          short: this.t('Value “Yes” — the path has no landing page.<br>Value “No” — the path includes landing pages.'),
          full: this.t('Value “Yes” — the path has no landing page.<br>Value “No” — the path includes landing pages.')
        },
        'flow_rule_paths-created': {
          short: this.t('Timestamp of path creation in UTC'),
          full: this.t('Timestamp of path creation in UTC')
        },
        'flow_rule_paths-updated': {
          short: this.t('Timestamp of the last change'),
          full: this.t('Timestamp of the last change')
        },
        'flow_rule_paths-updatedby': {
          short: this.t('Name of member who introduced the latest changes'),
          full: this.t('Name of member who introduced the latest changes')
        },
        'flow_rules-name': {
          short: this.t('Flow Rule Name'),
          full: this.t('Flow Rule Name')
        },
        'flow_rules-id': {
          short: this.t('Unique ID assigned to the flow rule in BeMob. If the column is empty, the campaign destination is built-in flow.'),
          full: this.t('Unique ID assigned to the flow rule in BeMob. If the column is empty, the campaign destination is built-in flow.')
        },
        'flow_rules-default': {
          short: this.t('Value “Yes” — the rule is default for the flow.<br>Value “No” — the rule is not default for the flow.'),
          full: this.t('Value “Yes” — the rule is default for the flow.<br>Value “No” — the rule is not default for the flow.'),
        },
        'flow_rules-number': {
          short: this.t('Serial number of the flow rule'),
          full: this.t('Serial number of the flow rule'),
        },
        'flow_rules-created': {
          short: this.t('Timestamp of rule creation in UTC'),
          full: this.t('Timestamp of rule creation in UTC'),
        },
        'flow_rules-updated': {
          short: this.t('Timestamp of the last change'),
          full: this.t('Timestamp of the last change'),
        },
        'flow_rules-updatedby': {
          short: this.t('Name of member who introduced the latest changes'),
          full: this.t('Name of member who introduced the latest changes'),
        },
        'reports-conversionswebview': {
          short: this.t('Displays conversions from WebView traffic.'),
          full: this.t('Displays conversions from WebView traffic.'),
        },
        'reports-conversionswebviewrevenue': {
          short: this.t('Displays the revenue received in the payout parameter for conversions with Click IDs identified by the system as WebView traffic.'),
          full: this.t('Displays the revenue received in the payout parameter for conversions with Click IDs identified by the system as WebView traffic.'),
        },
        'flow_rule_paths-weight': {
          short: this.t('The weight of the path that determines how traffic is distributed within the campaign.'),
          full: this.t('The weight of the path that determines how traffic is distributed within the campaign.'),
        },
        ...custom
      },

      metrics_options: {
        ...COMMON_METRICS.weight,
        ...customWeights
      },
      sort_exclude:[
        'campaigns-url',
        'offers-payout'
      ]

    } as Bemob.Metrics
  }
}
